export default __webpack_public_path__ + "static/media/HYPE_NIBIRU_2.3a392e00.mp4";